import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconErrorOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 18.333A1.334 1.334 0 1 1 16 21a1.334 1.334 0 0 1 0-2.667m0-7.666c.657 0 1.18.553 1.142 1.21l-.309 4.61a.835.835 0 0 1-1.666 0l-.309-4.61A1.144 1.144 0 0 1 16 10.666" /><path fill="currentColor" fillRule="evenodd" d="M15.369 3.224a1 1 0 0 1 1.338.069l12 12a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414 0l-12-12a1 1 0 0 1 0-1.414l12-12zM5.413 16 16 26.586 26.586 16 16 5.414z" clipRule="evenodd" /></svg>;
export default SvgIconErrorOutlined;